module.exports = __webpack_public_path__ + "static/4-798c8d8cc9deb06f9af82b3b3e2bd474.png";